export const formatPercent = (value, showSign = false, decimals = 1) => {
  if (value === null || value === undefined || isNaN(value)) return "--";
  const factor = Math.pow(10, decimals);
  const rounded = Math.round(value * factor) / factor || 0;
  const sign = showSign && rounded > 0 ? "+" : "";

  let formattedValue = formatNumber(rounded, decimals);

  if (decimals > 0 && formattedValue.endsWith(".0")) {
    formattedValue = formattedValue.slice(0, -2);
  }

  return `${sign}${formattedValue}%`;
};

export const getPerformanceColor = (value, type = "change") => {
  if (type === "neutral") return "#111827";
  if (value > 0) return "#2AA97A";
  if (value < 0) return "#FF6B6B";
  return "#111827";
};

export const formatNumber = (value, decimals = 0) => {
  if (value === null || value === undefined || isNaN(value)) return "--";
  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(value);
};

export const formatCurrency = (value) => {
  if (value === null || value === undefined || isNaN(value)) return "--";
  return `${formatNumber(value)} đ`;
};
